import { del, delBff, get, post, postBff, put, putBff } from './methods';

export enum EventAttachmentType {
  'VIDEO',
  'ATTACHMENT',
}

export interface VideoResponse {
  idVideo?: number;
  descricao: string;
  flagDisponivelAssociado: boolean;
  url: string;
}

export interface VideoRequest {
  idEvento: number;
  idVideo?: number;
  flagDisponivelAssociado: boolean;
  descricao: string;
  url: string;
}

export interface BatchVideoRequest {
  attachments: [
    {
      attachmentId: number;
      attachmentType: EventAttachmentType;
    }
  ];
}

const video = {
  listar: (idEvento: number) =>
    get<VideoResponse[]>('video/', {
      params: { idEvento },
    }),
  registrar: (data: VideoRequest) => post('video/', data),
  saveBff: (data: VideoRequest) => postBff('video/save', data),
  editar: (data: VideoRequest) => put('video/', data),
  editBff: (data: VideoRequest) => putBff('video/edit', data),
  apagar: (idEvento: number, idVideo: number) =>
    del(`video/${idEvento}/${idVideo}`),
  deleteBff: (eventId: string, videoId: number) =>
    delBff(`video/${eventId}/${videoId}`),
  deleteBatchBff: (eventId: number, data: BatchVideoRequest) =>
    postBff(`attachment/${eventId}`, data),
};

export default video;
